import React from "react";
import ProductHead from "../Components/ProductHead";
import Product from "../Components/Product";

const HomeCleaning = () => {
  return (
    <div>
      <ProductHead />
      <Product />
    </div>
  );
};

export default HomeCleaning;
